// @ts-ignore
import dashboardImage from "../../assets/dashboard3.png"
import * as React from "react"
import {useState} from "react"
// @ts-ignore
import {RegisterForm} from "../molecules/RegisterForm"
import {ModalPopup} from "../molecules/ModalPopup"
import {SigninForm} from "../molecules/SigninForm"

const HeroSection = () => {
    const [activeModal, setActiveModal] = useState('')

    return (
        <section className="w-full bg-white pt-32 pb-24">
            <div className="max-w-6xl mx-auto px-6 grid lg:grid-cols-2 gap-12 items-center">
                <div className="flex flex-col gap-6">
                    <span
                        className="inline-flex items-center self-start rounded-full bg-emerald-50 px-4 py-1.5 text-sm font-medium text-emerald-700 border border-emerald-200">
                        New: smarter send-time optimization
                    </span>
                    <h1 className="text-5xl md:text-6xl font-bold tracking-tight text-slate-900 leading-tight">
                        Email marketing that grows with you.
                    </h1>
                    <p className="text-base md:text-lg text-slate-600 leading-relaxed max-w-xl">
                        Design beautiful campaigns, reach the inbox, and watch revenue compound &mdash;
                        all from one calm, focused workspace.
                    </p>
                    <div className="flex items-center gap-6 pt-2">
                        <button
                            type="button"
                            onClick={() => setActiveModal('signup')}
                            className="rounded-full px-8 py-4 bg-emerald-500 hover:bg-emerald-600 text-white text-base font-semibold shadow-sm transition-colors duration-200">
                            Get started free
                        </button>
                        <a
                            href="/demo"
                            className="text-base font-medium text-slate-900 hover:text-emerald-600 transition-colors">
                            See a demo &rarr;
                        </a>
                    </div>
                    <p className="text-sm text-slate-500 pt-1">No credit card required &middot; Free for up to 500 contacts</p>
                </div>

                <div className="relative">
                    <div className="absolute -inset-6 bg-emerald-50 rounded-3xl -z-10"/>
                    <div className="rounded-2xl bg-white shadow-lg border border-slate-100 overflow-hidden">
                        <div className="flex items-center gap-2 px-4 py-3 border-b border-slate-100 bg-slate-50">
                            <span className="w-3 h-3 rounded-full bg-red-300"/>
                            <span className="w-3 h-3 rounded-full bg-amber-300"/>
                            <span className="w-3 h-3 rounded-full bg-emerald-400"/>
                            <span className="ml-3 text-xs text-slate-500">app.neugence.com / campaign</span>
                        </div>
                        <img
                            src={dashboardImage}
                            alt="Neugence Marketing dashboard preview"
                            className="w-full h-auto block"/>
                    </div>
                </div>
            </div>

            {activeModal !== '' && (
                <ModalPopup
                    onClose={() => setActiveModal('')}
                    children={activeModal === 'login' ?
                        <SigninForm onClose={() => setActiveModal('')} initialMode='signin'/> :
                        <RegisterForm onClose={() => setActiveModal('')} initialMode='signup'/>}
                    heading={activeModal === 'login' ? "SignIn" : "Signup"}
                    description={activeModal === 'login' ?
                        "Enter verification ID sent from Neugence Marketing" :
                        "Enter your email to register."}/>
            )}
        </section>
    )
}

export default HeroSection
